import { OperationHistoryItemType } from './types';

export const operationHistoryAmountClassNames: Record<OperationHistoryItemType, string> = {
  credit: 'text-success',
  debit: 'text-foreground'
};

export const operationHistoryIconClassNames: Record<OperationHistoryItemType, string> = {
  credit: 'bg-success/10 text-success',
  debit: 'bg-destructive/10 text-destructive'
};